import { Strings } from "src/modules/utils/shared/strings";
import { Component, OnInit, inject,
    ChangeDetectionStrategy
} from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AppMainComponent } from 'src/modules/app-template/components/app-main/app-main.component';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { FeatureModuleService } from 'src/modules/sm-base/services/feature-module.service';
import { SmBaseRoutingModule2 } from 'src/modules/sm-base/sm-base-routing2.module';
import { SmBaseModule } from 'src/modules/sm-base/sm-base.module';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Utils } from 'src/modules/utils/shared/utils';
import { PageNotFoundComponent } from "src/modules/app-template/components/page-not-found/page-not-found.component";

@Component({
    selector: 'root-component',
    standalone: false,
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class RootComponent implements OnInit {
    app = inject(MainAppService);
    featureModuleService = inject(FeatureModuleService);
    router = inject(Router);

    async ngOnInit(): Promise<void> {
        let modules = this.featureModuleService.getModules();

        if (Utils.isNoe(modules)) { 
            throw new Error("In der Konfigurationsdatei wurden keine Module registriert. Ohne Module ist das Portal nicht funktionsfähig");
        }

        for (let module of modules) {
            module.registerSidebar(this.app.menuModel);
        }

        if (this.app.mainConfig.useAdminUsers) {
            this.app.toolbarButtons = [...this.app.toolbarButtons,
                {
                    id: "admin",
                    label: "Administration",
                    routerLink: ["/base2", "admin"],
                    icon: "fas fa-cog",
                    visible: false
                }
            ];
        }

        this.app.menuModel = Arrays.sortBy(this.app.menuModel, item => item.sort);
        for (let tab of this.app.menuModel) {
            tab.menuItems = Arrays.sortBy(tab.menuItems, item => item.sort);
        }

        let childRoutes = modules.map(module => module.getMainRoute());
        childRoutes.push({
            path: "",
            redirectTo: Strings.def(this.app.mainConfig.mainRoute, childRoutes[0].path),
            pathMatch: "full"
        });
        childRoutes.push(this.featureModuleService.createModuleRoute("base2", () => SmBaseRoutingModule2));

        let routes: Routes = [
            {
                path: 'base',
                loadChildren: () => SmBaseModule
            },
            {
                path: '',
                component: AppMainComponent,
                children: childRoutes
            },
            { 
                path: '**', 
                component: PageNotFoundComponent 
            }
        ];

        this.router.resetConfig(routes);

        this.app.auth.onUserChanged.subscribe(async () => {
            await this.updateVisibility();
            if (this.app.mainConfig.usesChangeTracking) {
                await this.app.initChangeTracking();
            }            
        }, "RootComponent");
        await this.updateVisibility();
        if (this.app.auth.isLoggedIn() && this.app.mainConfig.usesChangeTracking) {
            await this.app.initChangeTracking();
        }     
    }

    private async updateVisibility(): Promise<void> {
        for (let module of this.featureModuleService.getModules()) {
            await module.updateSidebarVisibility(this.app.menuModel);
        }
        this.app.updateMenuVisibility();
        let b = this.app.toolbarButtons.find(tb => tb.id == "admin");
        if (b != null) {
            b.visible = this.app.isAdmin();
        }
    }
}